// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-up';

export const Component = () => (
  <path d='m11.848 5.353-5.124 5.124c-.144.24-.383.335-.719.335-.67 0-1.005-.335-1.005-.957 0-.192.096-.432.287-.67l6.849-6.898.144-.096c.287-.143.479-.191.575-.191.143 0 .335.048.575.191l.143.097 6.849 6.896a.946.946 0 0 1 .287.67c0 .623-.335.959-.957.959-.383 0-.623-.097-.767-.336l-5.124-5.124V20.68c0 .623-.335.958-1.006.958-.67 0-1.005-.335-1.005-.958V5.353h-.002Z' />
);

export const viewBox = '0 0 25 25';
